import { ReactElement } from "react"
import logo from '../../assets/loading-cartao-de-todos.webp'
import * as S from './franchise-error-style'

export function FranchiseError (): ReactElement {
  return <S.Container>
    <img src={logo} alt="Cartão de TODOS" />
    <p>Ocorreu um erro inesperado.</p>
    <p>Por favor tente novamente mais tarde!</p>
  </S.Container>
}